module.exports = __webpack_public_path__ + "img/loca_sub.2e0a5ef1.png";